export const addDashesToUUID = (u: string) =>
  u.replace(/(\w{8})(\w{4})(\w{4})(\w{4})(\w{12})/, '$1-$2-$3-$4-$5').toLowerCase();

export function encodeDisplayName(displayname: string) {
  return displayname.replace(/\s/g, '+');
}

export function decodeDisplayName(displayname: string) {
  return displayname.replace(/\+/g, ' ');
}
